import {
  ExpandablePanel,
  ExpandablePanelHeader,
  ExpandablePanelBody,
  InfoPanel,
  Typography,
} from "@king-ict/eupisi-ui/components";
import { hrDateWithTime } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import RequestHistoryItem from "../../../models/Request/RequestHistoryItem";
import styles from "./RequestDetailsPage.module.scss";

interface Props {
  requestHistory: RequestHistoryItem[];
  onExpandablePanelClick?: () => void;
}

export default function RequestHistory({
  requestHistory,
  onExpandablePanelClick,
}: Props) {
  const { t } = useTranslation();

  return (
    <Row className={styles.rowSpace}>
      <Col md={12}>
        <ExpandablePanel clickableHeader>
          <ExpandablePanelHeader onClick={onExpandablePanelClick}>
            {t("requestReviewStep.changeHistory")}
          </ExpandablePanelHeader>
          <ExpandablePanelBody>
            {!requestHistory.length ? (
              <InfoPanel
                message={t("requestReviewStep.changeHistoryInfo")}
                color="warning"
                fullWidth
              />
            ) : (
              <>
                {requestHistory.map((item) => (
                  <Row className={styles.rowHeadingSpace}>
                    <Col md={12}>
                      <ExpandablePanel clickableHeader>
                        <ExpandablePanelHeader
                          small
                          className={styles.subPanel}
                        >
                          <Row>
                            <Col md={4}>
                              <Typography variant="smallBold">
                                {hrDateWithTime(item.historyDate)}
                              </Typography>
                            </Col>
                            <Col md={4}>
                              <Typography variant="smallBold">
                                {item.user}
                              </Typography>
                            </Col>
                            <Col md={4}>
                              <Typography variant="smallBold">
                                {item.role}
                              </Typography>
                            </Col>
                          </Row>
                        </ExpandablePanelHeader>
                        <ExpandablePanelBody className={styles.subPanel}>
                          {item.details.map((detail) => (
                            <Row className={styles.rowSpace}>
                              <Col md={12}>
                                <Typography>{detail.text}</Typography>
                              </Col>
                            </Row>
                          ))}
                        </ExpandablePanelBody>
                      </ExpandablePanel>
                    </Col>
                  </Row>
                ))}
              </>
            )}
          </ExpandablePanelBody>
        </ExpandablePanel>
      </Col>
    </Row>
  );
}
